import "./PopupMenu.css";

const PopupMenu = ({ set, show, children, title }) => {
  return (
    <>
      <div
        className={`backdrop ${show ? "show" : ""}`}
        onClick={() => set(false)}
      />
      <div className={`popup-menu ${show ? "active" : ""}`}>
        <div className="popup-drag" />
        <div className="popup-content">
          <div className="title_menu">
            <div className="menu_name">
              <p>{title}</p>
            </div>
            <svg
              onClick={() => set(false)}
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              style={{ cursor: "pointer" }}
            >
              <CloseIcon />
            </svg>
          </div>
          {children}
        </div>
      </div>
    </>
  );
};

const CloseIcon = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M13.9484 15.6479C14.4177 16.1173 15.1786 16.1173 15.648 15.6479C16.1173 15.1786 16.1173 14.4177 15.648 13.9484L9.69956 7.99999L15.6479 2.05161C16.1173 1.58229 16.1173 0.821377 15.6479 0.352059C15.1786 -0.117259 14.4177 -0.117259 13.9484 0.352059L8.00001 6.30044L2.05155 0.351989C1.58223 -0.11733 0.821321 -0.117329 0.352003 0.351989C-0.117315 0.821307 -0.117316 1.58222 0.352003 2.05154L6.30046 7.99999L0.351989 13.9485C-0.11733 14.4178 -0.117329 15.1787 0.351989 15.648C0.821307 16.1173 1.58222 16.1173 2.05154 15.648L8.00001 9.69954L13.9484 15.6479Z"
    fill="black"
    opacity="0.6"
  />
);

export default PopupMenu;
